<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Calendario" name="calendar">
        <div class="calendario">
          <vue-event-calendar
            ref="calendar"
            :title="titulo"
            :events="datosSantoral"
            @month-changed="mesCambiado"
            @day-changed="diaCambiado"
          >
            <template slot-scope="props">
              <div v-for="(event, index) in props.showEvents" class="event-item card" :key="index">
                <div class="card-body">
                  <h3 class="card-title text-primary d-flex justify-content-between">
                    <span>{{event.title}}</span>
                    <el-tooltip
                      v-if="event.audio !== null"
                      class="item"
                      effect="dark"
                      :content="event.audio"
                      placement="top-end"
                    >
                      <a :href="event.audio" class="text-secondary">
                        <i class="fas fa-headphones"></i>
                      </a>
                    </el-tooltip>
                  </h3>
                  <h5 class="card-subtitle mt-1 mb-2 text-muted">{{event.biblicalRef}}</h5>
                  <p class="card-text mb-2">
                    <span class="badge badge-primary">{{event.date | moment('D [de] MMMM, YYYY')}}</span>
                  </p>
                  <small class="card-text">{{event.biblicalText}}</small>
                </div>
              </div>
            </template>
          </vue-event-calendar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Actualizar Santoral" name="uploadCSV" class="pt-3">
        <upload-csv></upload-csv>
      </el-tab-pane>
      <el-tab-pane label="Audios" name="audios" class="pt-3">
        <audios></audios>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from "axios";
import { APIENDPOINT } from "@/backend";
import UploadCSV from "./UploadCSV";
import Audios from "./Audios";

export default {
  name: "Calendar",
  components: {
    "upload-csv": UploadCSV,
    audios: Audios
  },

  data() {
    return {
      activeName: "calendar",
      titulo: "Evangelios de este mes",
      datosSantoral: []
    };
  },

  mounted: function() {
    this.$nextTick(function() {});
  },

  created: function() {
    this.$nextTick(function() {
      let primerDiaMesActual = this.$moment().format("YYYY[/]MM") + "/01";
      let ultimoDiaMesActual = this.$moment()
        .endOf("month")
        .format("YYYY[/]MM[/]DD");
      // console.log("primerDiaMesActual: " + primerDiaMesActual);
      // console.log("ultimoDiaMesActual: " + ultimoDiaMesActual);
      this.holydays(primerDiaMesActual, ultimoDiaMesActual);
      // this.testUser();
    });
  },

  methods: {
    diaCambiado(dia) {
      // console.log(dia.date);
      this.titulo = "Evangelio del día";
    },

    mesCambiado(mes) {
      const fromDate =
        mes
          .split("/")
          .reverse()
          .join("/") + "/01";
      const toDate = this.$moment(fromDate)
        .endOf("month")
        .format("YYYY[/]MM[/]DD");
      // console.log("fromDate: " + fromDate);
      // console.log("toDate: " + toDate);
      this.titulo = "Evangelios del mes";
      this.holydays(fromDate, toDate);
    },

    holydays: function(fromDate, toDate) {
      this.mensaje = "Buscando...";
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
          "content-type": "application/json"
        },
        method: "get",
        url: "/api/v1/holydays",
        params: { fromDate: fromDate, toDate: toDate }
      })
        .then(response => {
          this.datosSantoral = response.data.data.holydayList;
          // console.log(response.data.data.holydayList);
          if (this.datosSantoral.length === 0) {
            this.titulo = "Sin eventos";
          } else {
            // app.$EventCalendar.toDate(app.$moment().format('YYYY/MM/DD'));
            this.mensaje = "Resultados";
          }
        })
        .catch(function(error) {
          this.mensaje = "Error al buscar";
          console.log("El error más bonito del mundo está aquí ->" + error);
        });
    }
  }
};
</script>

<style lang="scss">
/* tabs */
.el-tabs__header {
  margin: 0 !important;
}

/* calendario */
.__vev_calendar-wrapper {
  display: flex;
}

.__vev_calendar-wrapper .events-wrapper {
  background-color: #964b8a !important;
  position: initial !important;
  height: 435px;
}

.__vev_calendar-wrapper .cal-wrapper .cal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 22px;
  font-weight: 300 !important;
  padding-bottom: 0 !important;
  height: 26px;
}

.__vev_calendar-wrapper .cal-wrapper .cal-body {
  margin-top: 15px;
}

.__vev_calendar-wrapper .cal-wrapper .cal-header .l,
.__vev_calendar-wrapper .cal-wrapper .cal-header .title,
.__vev_calendar-wrapper .cal-wrapper .cal-header .r {
  width: auto !important;
}

.__vev_calendar-wrapper .cal-wrapper .cal-header .title {
  margin-top: 4px;
}

.__vev_calendar-wrapper .cal-wrapper .cal-header > div {
  padding: 0 !important;
}

.__vev_calendar-wrapper .arrow-left.icon,
.__vev_calendar-wrapper .arrow-right.icon {
  margin-top: 0 !important;
  width: 12px;
  height: 26px;
}

.__vev_calendar-wrapper .arrow-left.icon::before,
.__vev_calendar-wrapper .arrow-right.icon::before {
  top: 4px !important;
  width: 16px !important;
  height: 16px !important;
}

.__vev_calendar-wrapper .arrow-left.icon {
  left: 2px !important;
}

.__vev_calendar-wrapper .arrow-right.icon {
  right: 2px !important;
}

.__vev_calendar-wrapper .events-wrapper .cal-events {
  height: 319px !important;
  margin: 30px 0 0 !important;
  padding: 0 !important;
}

.__vev_calendar-wrapper .events-wrapper .date {
  max-width: inherit !important;
  border-radius: 0 !important;
}

.__vev_calendar-wrapper .events-wrapper .event-item {
  padding: 5px 15px;
}

.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .dia-sel .is-event,
.badge-primary {
  background-color: #31022a !important;
}

/* media queries */
@media screen and (min-width: 768px) {
  .__vev_calendar-wrapper .cal-wrapper {
    padding: 30px 30px !important;
  }

  .__vev_calendar-wrapper .events-wrapper {
    padding: 30px 35px !important;
    border-radius: 0 !important;
  }
}
</style>
